import React, { useState } from "react";
import { Link } from "react-router-dom";

const Footer = ({ darkTheme }) => {
  const [logoHovered, setLogoHovered] = useState(false);
  
  const bgColor = darkTheme ? "#0a0a0a" : "#f5f5f5";
  const textColor = darkTheme ? "#aaa" : "#666";
  const textSecondary = darkTheme ? "#666" : "#999";
  const borderColor = darkTheme ? "#222" : "#e5e5e5";
  const cardBg = darkTheme ? "#111" : "#fff";
  const headingColor = darkTheme ? "#fff" : "#111";

  return (
    <footer style={{
      backgroundColor: bgColor,
      color: textColor,
      padding: "3rem 2rem 1.5rem",
      borderTop: `1px solid ${borderColor}`,
    }}>
      <div style={{
        maxWidth: "1400px",
        margin: "0 auto",
      }}>
        {/* TOP SECTION */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
          gap: "2rem",
          marginBottom: "2rem",
        }}>
          {/* Brand */}
          <div style={{ maxWidth: "320px" }}>
            {/* Logo */}
            <div
              style={{
                backgroundColor: "transparent",
                padding: "4px 0px",
                marginBottom: "1rem",
                transition: "all 0.3s ease",
                transform: logoHovered ? "scale(1.05)" : "scale(1)",
              }}
              onMouseEnter={() => setLogoHovered(true)}
              onMouseLeave={() => setLogoHovered(false)}
            >
              <Link to="/" style={{ display: "block" }}>
                <svg
                  width="110"
                  height="35"
                  viewBox="0 0 200 80"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "all 0.3s ease",
                  }}
                >
                  <text
                    x="0"
                    y="40"
                    fill={logoHovered ? "#ff0000" : darkTheme ? "#ffffff" : "#000000"}
                    fontFamily="Poppins, Arial, sans-serif"
                    fontSize="30"
                    fontWeight="700"
                    letterSpacing="1"
                    style={{ transition: "fill 0.3s ease" }}
                  >
                    FA
                  </text>
                  <text
                    x="40"
                    y="41"
                    fill={logoHovered ? (darkTheme ? "#ffffff" : "#000000") : "#ff0000"}
                    fontFamily="Poppins, Arial, sans-serif"
                    fontSize="36"
                    fontWeight="700"
                    style={{ transition: "fill 0.3s ease" }}
                  >
                    X
                  </text>
                  <text
                    x="65"
                    y="40"
                    fill={logoHovered ? "#ff0000" : darkTheme ? "#ffffff" : "#000000"}
                    fontFamily="Poppins, Arial, sans-serif"
                    fontSize="30"
                    fontWeight="700"
                    letterSpacing="1"
                    style={{ transition: "fill 0.3s ease" }}
                  >
                    ON
                  </text>
                  <text
                    x="0"
                    y="70"
                    fill={logoHovered ? "#ff0000" : darkTheme ? "#ffffff" : "#000000"}
                    fontFamily="Poppins, Arial, sans-serif"
                    fontSize="25"
                    fontWeight="700"
                    letterSpacing="0.5"
                    style={{ transition: "fill 0.3s ease" }}
                  >
                    Entertainment
                  </text>
                  <g transform="translate(120,15)">
                    <circle
                      cx="0"
                      cy="0"
                      r="6"
                      fill="none"
                      stroke={logoHovered ? "#ff0000" : darkTheme ? "#ffffff" : "#000000"}
                      strokeWidth="1"
                      style={{ transition: "stroke 0.3s ease" }}
                    />
                    <text
                      x="0"
                      y="2"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      fill={logoHovered ? "#ff0000" : darkTheme ? "#ffffff" : "#000000"}
                      fontFamily="Poppins, Arial, sans-serif"
                      fontSize="10"
                      fontWeight="700"
                      style={{ transition: "fill 0.3s ease" }}
                    >
                      {"\u2122"}
                    </text>
                  </g>
                </svg>
              </Link>
            </div>
            
            <p style={{
              fontSize: "0.85rem",
              lineHeight: "1.6",
              marginBottom: "1rem",
              color: darkTheme ? "#888" : "#666",
            }}>
              Professional artist management agency empowering African talent in 
              AmaPiano, Hip Hop, and RnB.
            </p>
            <div style={{
              display: "flex",
              gap: "0.7rem",
            }}>
              {[
                { name: "Instagram", url: "https://www.instagram.com/kgbwithadash.nft/", icon: "📷" },
                { name: "Facebook", url: "https://facebook.com/FaxonEnt", icon: "👍" },
                { name: "Twitter", url: "https://twitter.com/KGbwithadash", icon: "🐦" },
                { name: "LinkedIn", url: "https://www.linkedin.com/in/kagiso-mabule", icon: "💼" },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: "35px",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: cardBg,
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "1.1rem",
                    transition: "all 0.3s ease",
                    border: `1px solid ${borderColor}`,
                  }}
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 style={{
              fontSize: "1rem",
              fontWeight: "600",
              color: headingColor,
              marginBottom: "1rem",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}>Quick Links</h3>
            <ul style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}>
              {[
                { name: "Home", path: "/" },
                { name: "About", path: "/about" },
                { name: "Artists", path: "/artists" },
                { name: "Services", path: "/services" },
                { name: "Contact", path: "/contact" },
              ].map((link, i) => (
                <li key={i} style={{ marginBottom: "0.6rem" }}>
                  <Link to={link.path} style={{
                    color: textColor,
                    textDecoration: "none",
                    fontSize: "0.85rem",
                    transition: "color 0.3s ease",
                  }}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 style={{
              fontSize: "1rem",
              fontWeight: "600",
              color: headingColor,
              marginBottom: "1rem",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}>Our Services</h3>
            <ul style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}>
              {[
                "Artist Management",
                "Brand Development",
                "Tour Management",
                "Music Production",
              ].map((service, i) => (
                <li key={i} style={{ marginBottom: "0.6rem" }}>
                  <span style={{
                    color: textColor,
                    fontSize: "0.85rem",
                  }}>{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 style={{
              fontSize: "1rem",
              fontWeight: "600",
              color: headingColor,
              marginBottom: "1rem",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}>Contact Us</h3>
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.7rem",
            }}>
              <p style={{
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
                fontSize: "0.85rem",
                color: textColor,
              }}>
                <span style={{ fontSize: "1rem" }}>📧</span>
                <a href="mailto:kg.mabule@gmail.com" style={{
                  color: textColor,
                  textDecoration: "none",
                  transition: "color 0.3s ease",
                }}>
                  kg.mabule@gmail.com
                </a>
              </p>
              <p style={{
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
                fontSize: "0.85rem",
                color: textColor,
              }}>
                <span style={{ fontSize: "1rem" }}>📞</span>
                <a href="tel:0729753757" style={{
                  color: textColor,
                  textDecoration: "none",
                  transition: "color 0.3s ease",
                }}>
                  072 975 3757
                </a>
              </p>
              <p style={{
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
                fontSize: "0.85rem",
                color: textColor,
              }}>
                <span style={{ fontSize: "1rem" }}>👤</span>
                Kagiso Mabule
              </p>
              <p style={{
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
                fontSize: "0.85rem",
                color: textColor,
              }}>
                <span style={{ fontSize: "1rem" }}>📍</span>
                South Africa
              </p>
            </div>
          </div>
        </div>

        {/* DIVIDER */}
        <div style={{
          height: "1px",
          backgroundColor: borderColor,
          margin: "1.5rem 0",
        }}></div>

        {/* BOTTOM SECTION */}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
        }}>
          <p style={{
            fontSize: "0.8rem",
            color: textSecondary,
          }}>
            &copy; {new Date().getFullYear()} Faxon Entertainment (Pty) Ltd. All rights reserved.
          </p>
          <div style={{
            display: "flex",
            gap: "0.8rem",
            alignItems: "center",
          }}>
            <span style={{
              fontSize: "0.8rem",
              color: textSecondary,
              cursor: "pointer",
              transition: "color 0.3s ease",
            }}>Privacy Policy</span>
            <span style={{ color: darkTheme ? "#444" : "#ccc" }}>|</span>
            <span style={{
              fontSize: "0.8rem",
              color: textSecondary,
              cursor: "pointer",
              transition: "color 0.3s ease",
            }}>Terms of Service</span>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (max-width: 968px) {
            footer > div > div:first-child {
              grid-template-columns: 1fr !important;
            }
            footer > div > div:last-child {
              flex-direction: column;
              text-align: center;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;